import { render, staticRenderFns } from "./ParameterTemporary.vue?vue&type=template&id=61b4f20d&scoped=true&"
import script from "./ParameterTemporary.vue?vue&type=script&lang=js&"
export * from "./ParameterTemporary.vue?vue&type=script&lang=js&"
import style0 from "./ParameterTemporary.vue?vue&type=style&index=0&id=61b4f20d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61b4f20d",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VList } from 'vuetify/lib/components/VList';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemContent } from 'vuetify/lib/components/VList';
import { VListItemGroup } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VSlideYReverseTransition } from 'vuetify/lib/components/transitions';
installComponents(component, {VBtn,VCardActions,VCardText,VIcon,VList,VListItem,VListItemContent,VListItemGroup,VListItemTitle,VSelect,VSlideYReverseTransition})
